export interface AdjustmentAccounts {
    item: string
    number: number
    charge: number
}
export interface ObjectToAdjustmentAccountsProps {
    item: string
    number: number | string
    charge: number | string
}
export const ObjectToAdjustmentAccounts = (obj: ObjectToAdjustmentAccountsProps): AdjustmentAccounts => {
    return {
        item: obj.item,
        number: typeof obj.number === "string" ? parseInt(obj.number) : obj.number,
        charge: typeof obj.charge === "string" ? parseInt(obj.charge) : obj.charge,
    }
}